var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('v-chip',{attrs:{"small":"","dark":""}},[_vm._v("type: "+_vm._s(_vm.value.name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }